import type {
  PollData,
  PollsTableColumns,
  VoteData,
  VotesTableColumns
} from '@library/types/polls';
import type { TableColumn } from '@library/types/utils';

export const POLLS_TABLE_HEADER: Array<TableColumn<PollsTableColumns>> = [
  {
    column: 'id',
    essential: true,
    label: 'ID',
    sortEnabled: false,
    width: 'w-[5%] px-3'
  },
  {
    column: 'imageUrl',
    essential: true,
    label: 'Image',
    sortEnabled: false,
    width: 'w-[5%] px-3'
  },
  {
    column: 'question',
    essential: true,
    label: 'Poll',
    sortEnabled: false,
    width: 'w-[20%] px-3'
  },
  {
    column: 'description',
    essential: true,
    label: 'Description',
    sortEnabled: false,
    width: 'w-[20%] px-3'
  },
  {
    column: 'options',
    essential: true,
    label: 'Options',
    sortEnabled: false,
    width: 'w-[15%] px-3'
  },
  {
    column: 'winner',
    essential: true,
    label: 'Winner',
    sortEnabled: false,
    width: 'w-[10%] px-3'
  },
  {
    column: 'startAt',
    essential: true,
    label: 'Start Time',
    sortEnabled: false,
    width: 'w-[10%] px-3'
  },
  {
    column: 'endAt',
    essential: true,
    label: 'End Time',
    sortEnabled: false,
    width: 'w-[10%] px-3'
  },
  {
    column: 'actions',
    essential: true,
    label: 'Actions',
    sortEnabled: false,
    width: 'w-[5%] px-3'
  }
];

export const DEFAULT_POLL_DATA: PollData = {
  id: '',
  description: '',
  endAt: '',
  imageUrl: '',
  options: [],
  question: '',
  startAt: '',
  winner: null,
  bannerDescription: '',
  bannerHeadline: '',
  bannerCTA: ''
};

export const VOTES_TABLE_HEADER: Array<TableColumn<VotesTableColumns>> = [
  {
    column: 'question',
    essential: true,
    label: 'Question',
    sortEnabled: false,
    width: 'w-[25%] px-3'
  },
  {
    column: 'options',
    essential: true,
    label: 'Options',
    sortEnabled: false,
    width: 'w-[25%] px-3'
  },
  {
    column: 'selection',
    essential: true,
    label: 'Selection',
    sortEnabled: false,
    width: 'w-[25%] px-3'
  },
  {
    column: 'winner',
    essential: true,
    label: 'Winning Option',
    sortEnabled: false,
    width: 'w-[25%] px-3'
  }
];

export const DEFAULT_VOTE_DATA: VoteData = {
  id: '',
  question: '',
  options: [],
  selection: '',
  winner: ''
};
